import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FavGotoTopButton } from "./FavGotoTopButton";

interface FavouriteVideosProps {
  videos: any[];
  title: string;
  getVideos: (value: any) => void;
  onClick?: () => void;
}

export const FavouriteVideos: React.FC<FavouriteVideosProps> = ({
  videos,
  title,
  getVideos,
  onClick
}) => {
  const { t } = useTranslation();

  const [displayCount, setDisplayCount] = useState(4);
  const showMoreButton = () => {
    setDisplayCount(displayCount + 5); // Increase by a certain number
  };

  const showLessButton = () => {
    setDisplayCount(4); // Reset to initial display count
  };

  return (
    <div>
      {videos?.length > 0 ? (
        <div>
          <div>
            <p
              style={{
                fontFamily: "ChanakyaUni",
                fontWeight: 700,
                fontStyle: "normal",
                color: "#b42a38",
                fontSize: "26px",
                margin: "0 0 10px",
              }}
            >
              {title}
            </p>
            <div className="row" style={{ marginBottom: "21px", padding: "0 15px" }}>
              {videos.slice(0, displayCount).map((video: any) => (
                <div
                  className="col-3"
                  style={{
                    marginTop: "15px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div
                    onClick={() => {
                      getVideos(video);
                    }}
                    style={{
                      textAlign: "center",
                      height: "220px",
                      margin: "0 0 22px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <div>
                        <img
                          onClick={onClick}
                          style={{
                            height: "114px",
                            width: "199px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            marginBottom: "10px",
                            cursor: "pointer",
                          }}
                          src={`https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg`}
                          alt={video.name}
                        />
                        <p style={{
                          color: " #3f220d",
                          fontSize: "18px",
                          lineHeight: "22px",
                          margin: "10px 0 0",
                          fontStyle: "normal",
                          fontWeight: 600,
                          cursor: "pointer",
                        }}>
                          {video?.name}
                          {/* {video?.name?.length > 40
                            ? video?.name.slice(0, 35) + "..."
                            : video?.name} */}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="fav-section-actions">
            {videos?.length > 4 &&
              (displayCount < videos?.length ? (
                <button className="favitems" onClick={showMoreButton}>
                  {t("SeeAll_tr")}
                </button>
              ) : (
                <button className="favitems" onClick={showLessButton}>
                  {t("show_less_tr")}
                </button>
              ))}
            <FavGotoTopButton />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}; 